export interface Options {
  redirectUrl?: string;
}
